var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "budget-page" },
    [
      _c("div", { staticClass: "header-section" }, [
        _c("video", {
          staticClass: "desktop",
          attrs: {
            autoplay: "autoplay",
            playsinline: "",
            muted: "",
            loop: "loop",
            alt: "gif",
            src:
              "https://cdn.shopify.com/videos/c/o/v/680a27e4313e47cdbce0f534756b351e.mp4"
          },
          domProps: { muted: true }
        }),
        _vm._v(" "),
        _c("video", {
          staticClass: "mobile",
          attrs: {
            autoplay: "autoplay",
            playsinline: "",
            muted: "",
            loop: "loop",
            alt: "gif",
            src:
              "https://cdn.shopify.com/videos/c/o/v/4dbe17f6533a4d479d880b389f3d9346.mp4"
          },
          domProps: { muted: true }
        }),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "h-button",
            on: {
              click: function() {
                this$1.isWorking = true
              }
            }
          },
          [_vm._v("How it Works")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "top-section" }, [
        _c("div", { staticClass: "main-container" }, [
          _c("div", { staticClass: "n-container" }, [
            _c("div", { staticClass: "n-header" }, [
              _c("p", { staticClass: "legend" }, [_vm._v("Step 1 (of 3)")]),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("p", { staticClass: "main-title mobile" }, [
                _vm._v("Select your budget")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "budget-container", attrs: { id: "budget" } },
                _vm._l(_vm.normalGOC, function(collection) {
                  return _c(
                    "button",
                    {
                      key: collection.id,
                      staticClass: "happybox-button white border",
                      class: collection.id == _vm.normalId ? "selected" : "",
                      on: {
                        click: function() {
                          _vm.normalId = collection.id
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm._f("moneyFloatFormat")(collection)) +
                          "\n              "
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("p", { staticClass: "main-subtitle desktop" }, [
                _vm._v(
                  "All prices include US shipping. Scroll to see gift options"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "main-subtitle mobile" }, [
                _vm._v("All prices include US shipping.")
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "p-button",
                  on: {
                    click: function() {
                      this$1.isPreviewing = true
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "i",
                    attrs: {
                      src:
                        "https://cdn.shopify.com/s/files/1/1363/8433/files/eye.svg?v=1731361910"
                    }
                  }),
                  _vm._v("\n            Preview\n          ")
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.selectedNormalGOC,
                      expression: "selectedNormalGOC"
                    }
                  ],
                  staticClass: "happybox-button green border",
                  attrs: { id: "topbudget" },
                  on: {
                    click: function($event) {
                      return _vm.selectTopGOC(_vm.selectedNormalGOC)
                    }
                  }
                },
                [_vm._v("Step 2: Enter recipient information >")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "happybox-button green border",
                  class: !_vm.selectedNormalGOC ? "hidden" : "",
                  attrs: { href: "#budget", id: "backtop" }
                },
                [_vm._v("Back to Budget Selection ^")]
              )
            ]),
            _vm._v(" "),
            _vm.selectedNormalGOC &&
            _vm.selectedNormalGOC.collectionProducts &&
            _vm.selectedNormalGOC.collectionProducts.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "products-container",
                    attrs: { id: "budgetProducts" }
                  },
                  _vm._l(_vm.selectedCollectionProductsShown, function(
                    product
                  ) {
                    return _c(
                      "div",
                      { key: product.id, staticClass: "product-item" },
                      [
                        _vm.ethosTag(product)
                          ? _c(
                              "p",
                              {
                                staticClass: "main-badge",
                                class: _vm.badgeExtraClass(product)
                              },
                              [_vm._v(_vm._s(_vm.ethosTag(product)))]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "i",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/information.svg?v=1731080982"
                          },
                          on: {
                            click: function($event) {
                              return _vm.selectProduct(product)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "image-container" }, [
                          _c("img", {
                            staticClass: "lazyload",
                            attrs: { src: _vm._f("getProductImage")(product) },
                            on: {
                              click: function($event) {
                                return _vm.selectProduct(product)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "happybox-button white border",
                              on: {
                                click: function($event) {
                                  return _vm.selectTopGOC(_vm.selectedNormalGOC)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "Select " +
                                  _vm._s(
                                    _vm._f("moneyFloatFormat")(
                                      _vm.selectedNormalGOC
                                    )
                                  ) +
                                  " Collection"
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "product-title" }, [
                          _vm._v(_vm._s(product.title))
                        ])
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "spinner-container" }, [
                  _c("p", [_vm._v("amazing gifts are loading...")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "spinner" })
                ]),
            _vm._v(" "),
            _vm.selectedNormalGOC &&
            _vm.selectedNormalGOC.collectionProducts &&
            _vm.selectedNormalGOC.collectionProducts.length > 0
              ? _c(
                  "button",
                  {
                    staticClass: "show",
                    attrs: { id: "show" },
                    on: {
                      click: function($event) {
                        return _vm.changeShow()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          !_vm.showMore ? "Show More Gifts" : "Show Less Gifts"
                        ) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "normal-container" }, [
            _c("div", { staticClass: "title-header" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "arrows-container" }, [
                _c("img", {
                  staticClass: "l-arrow",
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546",
                    alt: "left arrow"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$refs.featured.prev()
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "r-arrow",
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546",
                    alt: "right arrow"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$refs.featured.next()
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm.featuredGOC.length == 0
              ? _c(
                  "div",
                  { staticClass: "collections-container" },
                  _vm._l(_vm.skeletons, function(n) {
                    return _c("FeaturedSkeleton", { key: n })
                  }),
                  1
                )
              : _c(
                  "div",
                  { staticClass: "collections-container" },
                  [
                    _c(
                      "Flicking",
                      {
                        ref: "featured",
                        staticClass: "flicking-goc-collection",
                        attrs: {
                          plugins: _vm.plugins1,
                          options: {
                            align: "prev",
                            circular: true,
                            preventDefaultOnDrag: true,
                            preventClickOnDrag: true,
                            panelsPerView: _vm.panels
                          }
                        }
                      },
                      [
                        _vm._l(_vm.featuredGOC, function(goc) {
                          return _c("FeaturedGOC", {
                            key: goc.id,
                            attrs: { goc: goc },
                            on: { selectgoc: _vm.selectGoc }
                          })
                        }),
                        _vm._v(" "),
                        _vm.isLoadingFeatured
                          ? _c("FeaturedSkeleton")
                          : _vm._e()
                      ],
                      2
                    )
                  ],
                  1
                )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "middle-section" }, [
        _c("div", { staticClass: "main-container" }, [
          _c("div", { staticClass: "normal-container" }, [
            _c("div", { staticClass: "title-header" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "arrows-container" }, [
                _c("img", {
                  staticClass: "l-arrow",
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546",
                    alt: "left arrow"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$refs.international.prev()
                    }
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "r-arrow",
                  attrs: {
                    src:
                      "https://cdn.shopify.com/s/files/1/1363/8433/files/white_button_square.svg?v=1720472546",
                    alt: "right arrow"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$refs.international.next()
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm.isLoading
              ? _c(
                  "div",
                  { staticClass: "collections-container" },
                  _vm._l(_vm.skeletons, function(n) {
                    return _c("SkeletonPlaceholder", { key: n })
                  }),
                  1
                )
              : _c(
                  "div",
                  { staticClass: "collections-container" },
                  [
                    _c(
                      "Flicking",
                      {
                        ref: "international",
                        staticClass: "flicking-goc-collection",
                        attrs: {
                          plugins: _vm.plugins3,
                          options: {
                            align: "prev",
                            circular: true,
                            preventDefaultOnDrag: true,
                            preventClickOnDrag: true,
                            panelsPerView: _vm.internationalPanels
                          }
                        }
                      },
                      [
                        _vm._l(_vm.intGOC, function(goc) {
                          return _c("NormalGOC", {
                            key: goc.id,
                            attrs: { goc: goc },
                            on: { selectgoc: _vm.selectGoc }
                          })
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.intGOC, function(goc) {
                          return _vm.intGOC.length < 5
                            ? _c("NormalGOC", {
                                key: goc.id + 1,
                                attrs: { goc: goc },
                                on: { selectgoc: _vm.selectGoc }
                              })
                            : _vm._e()
                        })
                      ],
                      2
                    )
                  ],
                  1
                )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bottom-section" },
        [_vm._m(4), _vm._v(" "), _c("Inquire"), _vm._v(" "), _c("FAQ")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isWorking,
              expression: "isWorking"
            }
          ],
          staticClass: "hiw-outer",
          on: {
            click: function() {
              this$1.isWorking = false
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "hiw",
              on: {
                click: function($event) {
                  $event.stopPropagation()
                }
              }
            },
            [
              _c("img", {
                staticClass: "x",
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
                  alt: "x"
                },
                on: {
                  click: function() {
                    this$1.isWorking = false
                  }
                }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "hiw-p" }, [_vm._v("HOW IT WORKS")]),
              _vm._v(" "),
              _c("img", {
                staticClass: "arrow-left",
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/blue_left_arrow.svg?v=1720018496"
                },
                on: {
                  click: function($event) {
                    return _vm.$refs.hiwflicking.prev()
                  }
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "arrow-right",
                attrs: {
                  src:
                    "https://cdn.shopify.com/s/files/1/1363/8433/files/blue_right_arrow.svg?v=1720018497"
                },
                on: {
                  click: function($event) {
                    return _vm.$refs.hiwflicking.next()
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "Flicking",
                {
                  ref: "hiwflicking",
                  attrs: {
                    options: {
                      align: "prev",
                      circular: true,
                      preventDefaultOnDrag: true,
                      preventClickOnDrag: true,
                      renderOnlyVisible: true
                    }
                  }
                },
                _vm._l(_vm.hiw, function(step) {
                  return _c("div", { staticClass: "hiw-panel" }, [
                    _c("img", {
                      staticClass: "lazyload",
                      attrs: { src: step.img }
                    }),
                    _vm._v(" "),
                    _c("p", { staticClass: "subtitle" }, [
                      _c("strong", [_vm._v(_vm._s(step.title) + ":")]),
                      _vm._v(" " + _vm._s(step.copy))
                    ])
                  ])
                }),
                0
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.selectedProduct
        ? _c("ProductModal", {
            attrs: { product: _vm.selectedProduct },
            on: {
              closemodal: function($event) {
                return _vm.selectProduct(null)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedNormalGOC && _vm.isPreviewing
        ? _c(
            "div",
            {
              staticClass: "send-modal",
              on: {
                click: function() {
                  this$1.isPreviewing = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "internal no-scrollbar",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "preview-header" }, [
                    _c("p", [_vm._v("You are currently viewing a preview")]),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "x",
                      attrs: {
                        src:
                          "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
                        alt: "x"
                      },
                      on: {
                        click: function() {
                          this$1.isPreviewing = false
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("TierMain", {
                    attrs: { collection: _vm.selectedNormalGOC },
                    on: {
                      close: function() {
                        this$1.isPreviewing = false
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { attrs: { id: "stickybudget" } }, [
        _c(
          "button",
          {
            staticClass: "happybox-button green border",
            on: {
              click: function($event) {
                return _vm.selectTopGOC(_vm.selectedNormalGOC)
              }
            }
          },
          [_vm._v("Next: Enter recipient information >")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-container" }, [
      _c("h2", [
        _vm._v("Let them pick "),
        _c("br", { staticClass: "desktop" }),
        _vm._v(" their perfect gift")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "main-subtitle" }, [
        _vm._v("Send a gift today or "),
        _c("br", { staticClass: "mobile" }),
        _vm._v(" schedule it for later")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "main-title desktop" }, [
      _c("span", [_vm._v("They")]),
      _vm._v(" pick their gift from the budget "),
      _c("span", [_vm._v("you")]),
      _vm._v(" select")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title-container" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Themed Collections")]),
      _vm._v(" "),
      _c("span", { staticClass: "subtitle" }, [
        _vm._v(
          "We've curated the perfect assortment of products by occasion and budget."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "title-container" }, [
      _c("span", { staticClass: "title" }, [
        _vm._v("Gifts that Ship Internationally")
      ]),
      _c("span", { staticClass: "subtitle" }, [
        _vm._v("Your gift value includes shipping costs")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "how-it-works" }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("Here's what each gift recipient will see.")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "instructions-container" }, [
        _c("div", { staticClass: "instruction" }, [
          _c("div", { staticClass: "main-image-container" }, [
            _c("img", {
              staticClass: "main-image lazyload",
              attrs: {
                "data-src":
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/email_4b763acd-5294-41b7-82ae-7fd39d559e9f.png?v=1733435878"
              }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "check" }, [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "desktop" }, [
              _vm._v("They receive an email prompting "),
              _c("br"),
              _vm._v(" them to select their gift & are "),
              _c("br"),
              _vm._v(" reminded weekly for 30 days")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "mobile" }, [
              _vm._v("They receive an email prompting "),
              _c("br"),
              _vm._v(" them to select their gift & are "),
              _c("br"),
              _vm._v(" reminded weekly for 30 days")
            ])
          ]),
          _vm._v(" "),
          _c("img", {
            staticClass: "m-arrow middle top",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_86d2a811-d7ca-41ff-b1ee-25044c4965e7.svg?v=1675281238"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "instruction" }, [
          _c("div", { staticClass: "main-image-container" }, [
            _c("img", {
              staticClass: "main-image lazyload",
              attrs: {
                "data-src":
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/time_to_pick_your_gift.png?v=1733435878"
              }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "check" }, [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "desktop" }, [
              _vm._v("They enter their shipping address.")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "mobile" }, [
              _vm._v("They enter their "),
              _c("br"),
              _vm._v(" shipping address.")
            ])
          ]),
          _vm._v(" "),
          _c("img", {
            staticClass: "m-arrow middle bottom",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/arrow_86d2a811-d7ca-41ff-b1ee-25044c4965e7.svg?v=1675281238"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "instruction" }, [
          _c("div", { staticClass: "main-image-container" }, [
            _c("img", {
              staticClass: "main-image lazyload",
              attrs: {
                "data-src":
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/gift_a8c259b9-a806-437a-ab38-2bf620194805.png?v=1733435878"
              }
            })
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "check" }, [
            _c("img", {
              attrs: {
                src:
                  "https://cdn.shopify.com/s/files/1/1363/8433/files/check_white.svg?v=1718978114"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "desktop" }, [
              _vm._v("They get exactly what they "),
              _c("br"),
              _vm._v(" want 1-2 weeks later")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "mobile" }, [
              _vm._v("They get exactly what they "),
              _c("br"),
              _vm._v(" want 1-2 weeks later")
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }